angular.module('rentalListingModule').component('rentalListingRegistrationForm', {
	templateUrl: 'rentalListingRegistrationForm/rentalListingRegistrationForm.html',
	bindings: {
		form: '<',
		formData: '<',
		loginType: '<',
		errorMessages: '<',
		termsOfUseUrl: '<',
		privacyPolicyUrl: '<',
		user: '<',
		formType: '@',
		isMobile: '<',
		showSendEmailsOptions: '<',
		placeholderName: '@',
		placeholderEmail: '@',
		placeholderPassword: '@',
		showPhoneNumber: '<',
		flags: '<',
		withRentalInquiries: '<',
		rpcRegistrationEmailValidation: '<',
		onFieldChange: '&',
		onValidateEmail: '&'
	},
	controller: ['$element', '$cookies', '$timeout', '$interval', 'patterns', function($element, $cookies, $timeout, $interval, patterns) {
		var ctrl = this;
		this.sendEmails = true;
		this.patterns = patterns;

		this.placeholderName = this.placeholderName || 'full name';
		this.placeholderEmail = this.placeholderEmail || 'email';
		this.placeholderPassword = this.placeholderPassword || 'password';

		if (this.flags) {
			if (this.user.name && this.user.email && this.user.password) {
				this.flags.showPhoneNumberField = true;
			}

			$element.on('$destroy', function() {
				ctrl.stopInterval();
			});
		}

		this.sendMeEmails = function() {
			if (this.sendEmails) {
				this.sendEmails = false;
			} else {
				this.sendEmails = true;
			}

			this.user.emailUpdates = this.sendEmails;
		};

		this.focus = function(field) {
			this.currentField = field;
		};

		this.checkIfShowPhoneNumber = function(field) {
			if (this.flags) {
				if (!this.flags.showPhoneNumberField && this.currentField === field && this.user.name && this.user.email && this.user.password) {
					this.flags.showPhoneNumberField = true;
				}
			}
		};

		this.blurEmail = function() {
			this.checkIfShowPhoneNumber('email');
			if (this.formType === 'sign-up') {
				if (this.user && this.user.email) {
					if (this.userEmailHasChanged) {
						this.onValidateEmail({email: this.user.email, form: this.form});
						this.userEmailHasChanged = false;
					}
				}
			}
		};

		this.fieldChange = function(key) {
			var self = this;

			if (this.flags) {
				this.stopInterval();
				this.startInterval();
			}

			this.onFieldChange({key: key});
		};

		this.startInterval = function() {
			var self = this;
			this.showPhoneFieldInterval = $interval(function() {
				if (!self.flags.showPhoneNumberField && self.user.name && self.user.email && self.user.password) {
					self.flags.showPhoneNumberField = true;
					self.stopInterval();
				}
			}, 500);
		};

		this.stopInterval = function() {
			if (angular.isDefined(this.showPhoneFieldInterval)) {
				$interval.cancel(this.showPhoneFieldInterval);
				this.showPhoneFieldInterval = undefined;
			}
		};

	}]
});